var map = {
	"./square/ac.svg": 1732,
	"./square/ad.svg": 1733,
	"./square/ae.svg": 1734,
	"./square/af.svg": 1735,
	"./square/ag.svg": 1736,
	"./square/ai.svg": 1737,
	"./square/al.svg": 1738,
	"./square/am.svg": 1739,
	"./square/ao.svg": 1740,
	"./square/aq.svg": 1741,
	"./square/ar.svg": 1742,
	"./square/as.svg": 1743,
	"./square/at.svg": 1744,
	"./square/au.svg": 1745,
	"./square/aw.svg": 1746,
	"./square/ax.svg": 1747,
	"./square/az.svg": 1748,
	"./square/ba.svg": 1749,
	"./square/bb.svg": 1750,
	"./square/bd.svg": 1751,
	"./square/be.svg": 1752,
	"./square/bf.svg": 1753,
	"./square/bg.svg": 1754,
	"./square/bh.svg": 1755,
	"./square/bi.svg": 1756,
	"./square/bj.svg": 1757,
	"./square/bl.svg": 1758,
	"./square/bm.svg": 1759,
	"./square/bn.svg": 1760,
	"./square/bo.svg": 1761,
	"./square/bq.svg": 1762,
	"./square/br.svg": 1763,
	"./square/bs.svg": 1764,
	"./square/bt.svg": 1765,
	"./square/bv.svg": 1766,
	"./square/bw.svg": 1767,
	"./square/by.svg": 1768,
	"./square/bz.svg": 1769,
	"./square/ca.svg": 1770,
	"./square/cc.svg": 1771,
	"./square/cd.svg": 1772,
	"./square/cefta.svg": 1773,
	"./square/cf.svg": 1774,
	"./square/cg.svg": 1775,
	"./square/ch.svg": 1776,
	"./square/ci.svg": 1777,
	"./square/ck.svg": 1778,
	"./square/cl.svg": 1779,
	"./square/cm.svg": 1780,
	"./square/cn.svg": 1781,
	"./square/co.svg": 1782,
	"./square/cp.svg": 1783,
	"./square/cr.svg": 1784,
	"./square/cu.svg": 1785,
	"./square/cv.svg": 1786,
	"./square/cw.svg": 1787,
	"./square/cx.svg": 1788,
	"./square/cy.svg": 1789,
	"./square/cz.svg": 1790,
	"./square/de.svg": 1791,
	"./square/dg.svg": 1792,
	"./square/dj.svg": 1793,
	"./square/dk.svg": 1794,
	"./square/dm.svg": 1795,
	"./square/do.svg": 1796,
	"./square/dz.svg": 1797,
	"./square/ea.svg": 1798,
	"./square/ec.svg": 1799,
	"./square/ee.svg": 1800,
	"./square/eg.svg": 1801,
	"./square/eh.svg": 1802,
	"./square/er.svg": 1803,
	"./square/es-ct.svg": 1804,
	"./square/es-ga.svg": 1805,
	"./square/es.svg": 1806,
	"./square/et.svg": 1807,
	"./square/eu.svg": 1808,
	"./square/fi.svg": 1809,
	"./square/fj.svg": 1810,
	"./square/fk.svg": 1811,
	"./square/fm.svg": 1812,
	"./square/fo.svg": 1813,
	"./square/fr.svg": 1814,
	"./square/ga.svg": 1815,
	"./square/gb-eng.svg": 1816,
	"./square/gb-nir.svg": 1817,
	"./square/gb-sct.svg": 1818,
	"./square/gb-wls.svg": 1819,
	"./square/gb.svg": 1820,
	"./square/gd.svg": 1821,
	"./square/ge.svg": 1822,
	"./square/gf.svg": 1823,
	"./square/gg.svg": 1824,
	"./square/gh.svg": 1825,
	"./square/gi.svg": 1826,
	"./square/gl.svg": 1827,
	"./square/gm.svg": 1828,
	"./square/gn.svg": 1829,
	"./square/gp.svg": 1830,
	"./square/gq.svg": 1831,
	"./square/gr.svg": 1832,
	"./square/gs.svg": 1833,
	"./square/gt.svg": 1834,
	"./square/gu.svg": 1835,
	"./square/gw.svg": 1836,
	"./square/gy.svg": 1837,
	"./square/hk.svg": 1838,
	"./square/hm.svg": 1839,
	"./square/hn.svg": 1840,
	"./square/hr.svg": 1841,
	"./square/ht.svg": 1842,
	"./square/hu.svg": 1843,
	"./square/ic.svg": 1844,
	"./square/id.svg": 1845,
	"./square/ie.svg": 1846,
	"./square/il.svg": 1847,
	"./square/im.svg": 1848,
	"./square/in.svg": 1849,
	"./square/io.svg": 1850,
	"./square/iq.svg": 1851,
	"./square/ir.svg": 1852,
	"./square/is.svg": 1853,
	"./square/it.svg": 1854,
	"./square/je.svg": 1855,
	"./square/jm.svg": 1856,
	"./square/jo.svg": 1857,
	"./square/jp.svg": 1858,
	"./square/ke.svg": 1859,
	"./square/kg.svg": 1860,
	"./square/kh.svg": 1861,
	"./square/ki.svg": 1862,
	"./square/km.svg": 1863,
	"./square/kn.svg": 1864,
	"./square/kp.svg": 1865,
	"./square/kr.svg": 1866,
	"./square/kw.svg": 1867,
	"./square/ky.svg": 1868,
	"./square/kz.svg": 1869,
	"./square/la.svg": 1870,
	"./square/lb.svg": 1871,
	"./square/lc.svg": 1872,
	"./square/li.svg": 1873,
	"./square/lk.svg": 1874,
	"./square/lr.svg": 1875,
	"./square/ls.svg": 1876,
	"./square/lt.svg": 1877,
	"./square/lu.svg": 1878,
	"./square/lv.svg": 1879,
	"./square/ly.svg": 1880,
	"./square/ma.svg": 1881,
	"./square/mc.svg": 1882,
	"./square/md.svg": 1883,
	"./square/me.svg": 1884,
	"./square/mf.svg": 1885,
	"./square/mg.svg": 1886,
	"./square/mh.svg": 1887,
	"./square/mk.svg": 1888,
	"./square/ml.svg": 1889,
	"./square/mm.svg": 1890,
	"./square/mn.svg": 1891,
	"./square/mo.svg": 1892,
	"./square/mp.svg": 1893,
	"./square/mq.svg": 1894,
	"./square/mr.svg": 1895,
	"./square/ms.svg": 1896,
	"./square/mt.svg": 1897,
	"./square/mu.svg": 1898,
	"./square/mv.svg": 1899,
	"./square/mw.svg": 1900,
	"./square/mx.svg": 1901,
	"./square/my.svg": 1902,
	"./square/mz.svg": 1903,
	"./square/na.svg": 1904,
	"./square/nc.svg": 1905,
	"./square/ne.svg": 1906,
	"./square/nf.svg": 1907,
	"./square/ng.svg": 1908,
	"./square/ni.svg": 1909,
	"./square/nl.svg": 1910,
	"./square/no.svg": 1911,
	"./square/np.svg": 1912,
	"./square/nr.svg": 1913,
	"./square/nu.svg": 1914,
	"./square/nz.svg": 1915,
	"./square/om.svg": 1916,
	"./square/pa.svg": 1917,
	"./square/pe.svg": 1918,
	"./square/pf.svg": 1919,
	"./square/pg.svg": 1920,
	"./square/ph.svg": 1921,
	"./square/pk.svg": 1922,
	"./square/pl.svg": 1923,
	"./square/pm.svg": 1924,
	"./square/pn.svg": 1925,
	"./square/pr.svg": 1926,
	"./square/ps.svg": 1927,
	"./square/pt.svg": 1928,
	"./square/pw.svg": 1929,
	"./square/py.svg": 1930,
	"./square/qa.svg": 1931,
	"./square/re.svg": 1932,
	"./square/ro.svg": 1933,
	"./square/rs.svg": 1934,
	"./square/ru.svg": 1935,
	"./square/rw.svg": 1936,
	"./square/sa.svg": 1937,
	"./square/sb.svg": 1938,
	"./square/sc.svg": 1939,
	"./square/sd.svg": 1940,
	"./square/se.svg": 1941,
	"./square/sg.svg": 1942,
	"./square/sh.svg": 1943,
	"./square/si.svg": 1944,
	"./square/sj.svg": 1945,
	"./square/sk.svg": 1946,
	"./square/sl.svg": 1947,
	"./square/sm.svg": 1948,
	"./square/sn.svg": 1949,
	"./square/so.svg": 1950,
	"./square/sr.svg": 1951,
	"./square/ss.svg": 1952,
	"./square/st.svg": 1953,
	"./square/sv.svg": 1954,
	"./square/sx.svg": 1955,
	"./square/sy.svg": 1956,
	"./square/sz.svg": 1957,
	"./square/ta.svg": 1958,
	"./square/tc.svg": 1959,
	"./square/td.svg": 1960,
	"./square/tf.svg": 1961,
	"./square/tg.svg": 1962,
	"./square/th.svg": 1963,
	"./square/tj.svg": 1964,
	"./square/tk.svg": 1965,
	"./square/tl.svg": 1966,
	"./square/tm.svg": 1967,
	"./square/tn.svg": 1968,
	"./square/to.svg": 1969,
	"./square/tr.svg": 1970,
	"./square/tt.svg": 1971,
	"./square/tv.svg": 1972,
	"./square/tw.svg": 1973,
	"./square/tz.svg": 1974,
	"./square/ua.svg": 1975,
	"./square/ug.svg": 1976,
	"./square/um.svg": 1977,
	"./square/un.svg": 1978,
	"./square/us.svg": 1979,
	"./square/uy.svg": 1980,
	"./square/uz.svg": 1981,
	"./square/va.svg": 1982,
	"./square/vc.svg": 1983,
	"./square/ve.svg": 1984,
	"./square/vg.svg": 1985,
	"./square/vi.svg": 1986,
	"./square/vn.svg": 1987,
	"./square/vu.svg": 1988,
	"./square/wf.svg": 1989,
	"./square/ws.svg": 1990,
	"./square/xk.svg": 1991,
	"./square/xx.svg": 1992,
	"./square/ye.svg": 1993,
	"./square/yt.svg": 1994,
	"./square/za.svg": 1995,
	"./square/zm.svg": 1996,
	"./square/zw.svg": 1997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1731;